<template>
  <b-container class="p-3" fluid>
    <portal to="project-action-bar">
      <b-button variant="success" class="mr-2" :disabled="!isSubmitable && !isSaving" @click="submit">
        <font-awesome-icon v-if="!isSaving" icon="save" />
        <b-spinner v-else class="mr-1" small />
        บันทึก
      </b-button>
      <b-button variant="outline-secondary" @click="discardEdit({ name: 'projects.show.proposal.budget', params: $route.params })">
        <font-awesome-icon icon="times" />ย้อนกลับ
      </b-button>
    </portal>

    <loading-spinner v-if="isLoading" text="กำลังโหลด..." />

    <b-row v-else>
      <b-col>
        <create-form-budget-planning
          ref="form"
          v-model="form"
          @ready="state => isSubmitable = state"
          @dirty="state => isDirty = state"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CreateFormBudgetPlanning from '@/components/project/create/CreateFormBudgetPlanning'
import projectEditMixins from '@/mixins/projectEditMixins'
import _ from 'lodash'

export default {
  components: {
    CreateFormBudgetPlanning
  },
  mixins: [ projectEditMixins ],
  data: () => ({
    form: {
      expenses: {},
      funding: {}
    }
  }),
  created () {
    this.$store.dispatch('project/loadBudget', this.$route.params.id).then(() => {
      this.form.expenses = _.cloneDeep(this.project.expenses)
      this.form.funding = _.cloneDeep(this.project.funding)
      this.isLoading = false
    })
  },
  methods: {
    async submit () {
      if (!this.$refs.form.validate()) {
        this.isSubmitable = false
        this.flashValidationErrorToast()
        return
      }

      this.cleanExpensesTablePayload()

      try {
        await this.$store.dispatch('project/patchProposal', { id: this.$route.params.id, ...this.form })
        await this.flashSaveSuccessToast()
        this.$router.push({ name: 'projects.show.proposal.budget', params: this.$route.params })
      } catch {
        this.flashValidationErrorToast()
      }
    },
    cleanExpensesTablePayload () {
      this.form.expenses = _.each(this.form.expenses, expenseGroup => {
        if (typeof expenseGroup === 'string') {
          return
        }

        _.each(expenseGroup, expense => {
          expense.qty = expense.qty === '' ? null : expense.qty
          expense.times = expense.times === '' ? null : expense.times
          expense.amountEach = expense.amountEach === '' ? null : expense.amountEach
          expense.amountQty = expense.amountQty === '' ? null : expense.amountQty
          return expense
        })
        return expenseGroup
      })
    }
  }
}
</script>
